'use client';
import { PropsWithChildren } from 'react';
import { FormProvider } from 'react-hook-form';
import { EquipmentFormProps } from './types';

export const EquipmentForm = ({
  children,
  formMethods,
  handleSubmit,
  classname
}: PropsWithChildren<EquipmentFormProps>) => {
  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit} className={classname}>
        {children}
      </form>
    </FormProvider>
  );
};
